__turbopack_context__.v({
  "anchorTarget": "ExpertCtaStrip-module__LI75kq__anchorTarget",
  "birdeyeCol": "ExpertCtaStrip-module__LI75kq__birdeyeCol",
  "caption": "ExpertCtaStrip-module__LI75kq__caption",
  "contentCol": "ExpertCtaStrip-module__LI75kq__contentCol",
  "phoneDesktopOnly": "ExpertCtaStrip-module__LI75kq__phoneDesktopOnly",
  "phoneHeading": "ExpertCtaStrip-module__LI75kq__phoneHeading",
  "phoneLink": "ExpertCtaStrip-module__LI75kq__phoneLink",
  "phoneMobileOnly": "ExpertCtaStrip-module__LI75kq__phoneMobileOnly",
  "row": "ExpertCtaStrip-module__LI75kq__row",
  "strip": "ExpertCtaStrip-module__LI75kq__strip",
  "stripDesktop": "ExpertCtaStrip-module__LI75kq__stripDesktop",
  "stripMobile": "ExpertCtaStrip-module__LI75kq__stripMobile",
});
